module.exports = __webpack_public_path__ + "static/media/subGoogle4.beb528d0.png";